import { FormPage } from '@checkit/react-components';
import { AddIcon } from '@checkit/react-components/build/components/Icons';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps } from 'react-router-dom';
import { AnyAction } from 'redux';

import { useAxiosDispatch } from '../../middleware/axios';
import { createSnackbar } from '../../notifications/actions';
import { createCheckpoint, isCreateCheckpointSuccess } from '../actions';
import { messages as messagesCommon } from '../common.translations';
import CheckpointForm from '../components/form/CheckpointForm';
import { CheckpointDto } from '../state';

import { messages } from './NewCheckpoint.translations';

export const NewCheckpoint: FC<RouteComponentProps> = ({ history }) => {
  const {formatMessage} = useIntl();
  const dispatch = useAxiosDispatch( );

  const onSubmit = async (data: CheckpointDto): Promise<AnyAction> => {
    const action = await dispatch(createCheckpoint(data, history));

    if (isCreateCheckpointSuccess(action)) {
      dispatch(createSnackbar({
        message: formatMessage(messages['checkpoint.new.success']),
        options: {
          variant: 'success'
        }
      }));
    } else {
      const errorType = action.error ? (action as any).error.response.data.message : null;
      if (errorType === messagesCommon.CHECKPOINT_NAME_NOT_UNIQUE.id) {
        dispatch(createSnackbar({
          message: formatMessage(messagesCommon.CHECKPOINT_NAME_NOT_UNIQUE),
          options: {
            autoHideDuration: 5000,
            variant: 'error'
          }
        }));
      } else if (errorType === messagesCommon.QR_CODE_NOT_UNIQUE.id) {
        dispatch(createSnackbar({
          message: formatMessage(messagesCommon.QR_CODE_NOT_UNIQUE),
          options: {
            autoHideDuration: 5000,
            variant: 'error'
          }
        }));
      } else {
        dispatch(createSnackbar({
          message: formatMessage(messages['checkpoint.new.error']),
          options: {
            variant: 'error'
          }
        }));
      }
    }
    return action;
  };
  return (
    <FormPage pageTitle={formatMessage(messages['checkpoint.new.pageTitle'])} pageIcon={<AddIcon/>}>
      <CheckpointForm onSubmit={onSubmit}/>
    </FormPage>
  );
};
